// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"0309e8a49034fe73eafa","147":"436613aa61f90806b0c3","251":"8f79a8938b80aa13621e","352":"7bc2a2440d638ddb10e1","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};